import { render } from "./WebShopFailed.vue?vue&type=template&id=34217962&scoped=true&ts=true"
import script from "./WebShopFailed.vue?vue&type=script&lang=ts"
export * from "./WebShopFailed.vue?vue&type=script&lang=ts"

import "./WebShopFailed.vue?vue&type=style&index=0&id=34217962&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34217962"]])

export default __exports__